import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'biz-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  public searchText = '';
  public isSearchMode = false;
  private _searchDebounce = new Subject();
  @Input() packageName?= '';
  @Input() displayName: string = '';
  @Input() showSearch: boolean = true;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSetSearchMode: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSearchText: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    this._searchDebounce.pipe(debounceTime(600)).subscribe(() => {
      this.onSearchText.emit(this.searchText);
    });
  }

  public closePackageVisualizerDetail() {
    this.onClose.emit();
  }

  public setSearchMode(searchMode: boolean) {
    this.isSearchMode = searchMode;
    this.onSetSearchMode.emit(searchMode);
  }

  public endSearchMode() {
    this.searchText = '';
    this.setSearchMode(false);
  }

  public onKeyUp() {
    this._searchDebounce.next(null);
  }
}
